module.exports = __webpack_public_path__ + "img/landscape_2.8582c973.jpg";